export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  JWT_TOKEN: 'JWT_TOKEN',
  USER_ID: 'USER_ID',
  WS_TOKEN: 'WS_TOKEN',
};
